<div class="row" [class.no-gutters]="!block.settings.gutters">

  <div *ngFor="let b of columns"
       class="col-12"
       [class]="$any(b).settings.size">

    <app-drop-zone [block]="b" [parent]="block" [disabled]="!blocksConfig.editable">

      <app-column *ngIf="b.id" [block]="b" [ngClass]="block.settings.justify"></app-column>

    </app-drop-zone>

  </div>

</div>
